import { GetIntegrationsV2ResponseSchema } from "@redotech/internal-ctx-client";
import * as z from "zod";

export const getContextualIntegrations = {
  name: "getContextualIntegrations" as const,
  input: z.object({}),
  output: GetIntegrationsV2ResponseSchema,
};
